// eslint-disable-next-line import/no-extraneous-dependencies
import Swiper from 'swiper/bundle';
import { swiperOptions } from './module/SwiperFunctions';

document.addEventListener('DOMContentLoaded', () => {
  //nearSpot__swiper
  if (document.querySelector('.nearSpot__swiper')) {
    new Swiper(
      '.nearSpot__swiper',
      swiperOptions({
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: false,
        speed: 3000,
        navigation: {
          nextEl: '.u-swiperButton__next',
          prevEl: '.u-swiperButton__prev',
        },
        pagination: {
          el: '.show__swiperPagination',
          bulletClass: 'u-swiperPaginationBullet',
          bulletActiveClass: 'u-swiperPaginationBullet--active',
          clickable: true,
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
          },
        },
      })
    );
  }
  //related_featuret__swiper
  if (document.querySelector('.related_featuret__swiper')) {
    new Swiper(
      '.related_featuret__swiper',
      swiperOptions({
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: false,
        speed: 3000,
        navigation: {
          nextEl: '.u-swiperButton__next',
          prevEl: '.u-swiperButton__prev',
        },
        pagination: {
          el: '.show__swiperPagination',
          bulletClass: 'u-swiperPaginationBullet',
          bulletActiveClass: 'u-swiperPaginationBullet--active',
          clickable: true,
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
          },
        },
      })
    );
  }
  //related_event__swiper
  if (document.querySelector('.related_event__swiper')) {
    new Swiper(
      '.related_event__swiper',
      swiperOptions({
        slidesPerView: 1,
        spaceBetween: 20,
        speed: 3000,
        centeredSlides: false,
        navigation: {
          nextEl: '.u-swiperButton__next',
          prevEl: '.u-swiperButton__prev',
        },
        pagination: {
          el: '.show__swiperPagination',
          bulletClass: 'u-swiperPaginationBullet',
          bulletActiveClass: 'u-swiperPaginationBullet--active',
          clickable: true,
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
          },
        },
      })
    );
  }
});
